(function () {
  /* Chuẩn hóa text */
  function normText(s) {
    return (s || '').replace(/\s+/g, ' ').trim();
  }

  /* Xác định line item có phải Material hay không */
  function isMaterialItem(item) {
    if (!item) return false;

    /* 1. Check title/name (ưu tiên) */
    var nameEl = item.querySelector(
      '.cart-item__name, .cart-item__title, [data-cart-item-title]'
    );

    var name = normText(nameEl ? nameEl.textContent : '');

    // Khớp chính xác theo case bạn đang dùng
    if (name === 'Material:') return true;

    /* 2. Fallback: check toàn bộ text trong item */
    var allText = normText(item.textContent || '');

    // Bắt chắc label Material:
    if (allText.indexOf('Material:') !== -1) return true;

    return false;
  }

  /* Ẩn nút remove cho Material */
  function hideRemoveForMaterial() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var removeBtns = drawer.querySelectorAll(
      'cart-remove-button, [id^="CartDrawer-Remove-"], button[name="remove"]'
    );

    for (var i = 0; i < removeBtns.length; i++) {
      var btn = removeBtns[i];

      /* Tìm line item cha */
      var item = btn.closest
        ? btn.closest('li[id^="CartDrawer-Item-"], .cart-drawer-item, .cart-item')
        : null;

      if (!item) continue;
      if (!isMaterialItem(item)) continue;

      /* Ẩn hoàn toàn – không chiếm layout */
      btn.style.pointerEvents = 'none';
      btn.style.cursor = 'default';
      btn.style.display = 'none';

      /* Phòng trường hợp có button con */
      var innerBtn = btn.querySelector('button');
      if (innerBtn) {
        innerBtn.style.pointerEvents = 'none';
        innerBtn.style.cursor = 'default';
        innerBtn.style.display = 'none';
      }
    }
  }

  /* Chạy lần đầu */
  hideRemoveForMaterial();

  /* Shrine re-render Cart Drawer → dùng MutationObserver */
  var drawerEl = document.getElementById('CartDrawer');
  if (drawerEl && window.MutationObserver) {
    var observer = new MutationObserver(function () {
      hideRemoveForMaterial();
    });
    observer.observe(drawerEl, { childList: true, subtree: true });
  }

  /* Hook thêm event (phòng theme update cart) */
  document.addEventListener('cart:updated', hideRemoveForMaterial);
  document.addEventListener('cart:refresh', hideRemoveForMaterial);
})();
